import React from 'react';
import './ProductCard.css'; // Fichier CSS pour la carte

// Ce composant reçoit les détails du produit via les props
function ProductCard({ imageSrc, name, description }) {
  return (
    <div className="product-card">
      <div className="product-card-image-container">
        {/* Utilise le chemin de l'image et le nom passés en props */}
        {/* Rappel: le chemin commence par /images/ si l'image est dans public/images */}
        <img
          src={imageSrc}
          alt={name}
          className="product-card-image"
          loading="lazy"
        />
      </div>
      <div className="product-card-content">
        <h3 className="product-card-name">{name}</h3>
        <p className="product-card-description">{description}</p>
        {/* Optionnel: Ajouter un bouton/lien ici si nécessaire */}
        {/* <a href="#" className="product-card-button">Voir plus</a> */}
      </div>
    </div>
  );
}

export default ProductCard;